import { PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { CacheProvider } from '@emotion/react';
import { EmotionCache } from '@emotion/cache';

type RootThemeProps = PropsWithChildren<{ emotionCache: EmotionCache }>;

export function RootThemeProvider(props: RootThemeProps) {
	const { children, emotionCache } = props;

	return (
		<CacheProvider value={emotionCache}>
			<ThemeProvider theme={theme}>
				{children}
			</ThemeProvider>
		</CacheProvider>
	);
}
